module.exports = __webpack_public_path__ + "img/59.a5d8ca50.jpg";